<template>
  <q-list>
    <slot/>
  </q-list>
</template>

<script>
export default {
  name: 'RList',
};
</script>
